module.exports = __webpack_public_path__ + "static/media/WarningIcon.dc590b2f.svg";